<shabic-layout>
  <shabic-header header></shabic-header>
  <div>
    <div class="bg-grey-300 py-7">
      <div class="grid grid-cols-2 items-center justify-between" shabicLayoutContent>
        <shabic-headline variant="h1">
          Supplier EDI Reports
        </shabic-headline>
      </div>
    </div>
    <div shabicLayoutContent>
      <div class="mt-6 mb-5 flex justify-between items-center gap-2"></div>
      <div *ngIf="loading" class="text-center py-10 text-primary font-bold">Loading...</div>
      <div *ngIf="error" class="text-center py-10 text-red font-bold">{{ error }}</div>
      <div class="overflow-x-auto" *ngIf="!loading && !error">
        <table class="w-full mb-10">
          <thead class="border-y border-grey-300">
            <tr>
              <th class="font-bold text-[10px] text-primary whitespace-nowrap uppercase ltr:text-left rtl:text-right py-4 px-3">ID</th>
              <th class="font-bold text-[10px] text-primary whitespace-nowrap uppercase ltr:text-left rtl:text-right py-4 px-3">Supplier ID</th>
              <th class="font-bold text-[10px] text-primary whitespace-nowrap uppercase ltr:text-left rtl:text-right py-4 px-3">Report Date</th>
              <th class="font-bold text-[10px] text-primary whitespace-nowrap uppercase ltr:text-left rtl:text-right py-4 px-3">Created Date</th>
              <th class="font-bold text-[10px] text-primary whitespace-nowrap uppercase ltr:text-left rtl:text-right py-4 px-3">Sending Method</th>
              <th class="font-bold text-[10px] text-primary whitespace-nowrap uppercase ltr:text-left rtl:text-right py-4 px-3">Status</th>
              <th class="font-bold text-[10px] text-primary whitespace-nowrap uppercase ltr:text-left rtl:text-right py-4 px-3">File Name</th>
              <th class="font-bold text-[10px] text-primary whitespace-nowrap uppercase ltr:text-left rtl:text-right py-4 px-3">Download</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let report of reports" class="border-b border-grey-300">
              <td class="py-2 px-3 text-sm text-primary align-middle">{{ report.id }}</td>
              <td class="py-2 px-3 text-sm text-primary align-middle">{{ report.supplierId }}</td>
              <td class="py-2 px-3 text-sm text-primary align-middle">{{ report.reportDate }}</td>
              <td class="py-2 px-3 text-sm text-primary align-middle">{{ report.createdDate }}</td>
              <td class="py-2 px-3 text-sm text-primary align-middle">{{ report.sendingMethod }}</td>
              <td class="py-2 px-3 text-sm text-primary align-middle">{{ report.status }}</td>
              <td class="py-2 px-3 text-sm text-primary align-middle">{{ report.fileName }}</td>
              <td class="py-2 px-3 text-sm text-primary align-middle">
                <a *ngIf="report.fileUrl" [href]="report.fileUrl" target="_blank" rel="noopener noreferrer" shabicButton="primary">Download</a>
              </td>
            </tr>
            <tr *ngIf="reports.length === 0">
              <td colspan="8" class="text-center py-6 text-grey-500">No reports found.</td>
            </tr>
          </tbody>
        </table>
        <div class="flex justify-center gap-2 mb-10" *ngIf="totalPages > 1">
          <button shabicButton="default" [disabled]="currentPage === 1" (click)="changePage(currentPage - 1)">&lt;</button>
          <ng-container *ngFor="let page of [].constructor(totalPages); let i = index">
            <button shabicButton="default" [class.bg-primary]="currentPage === i + 1" [class.text-white]="currentPage === i + 1" (click)="changePage(i + 1)">{{ i + 1 }}</button>
          </ng-container>
          <button shabicButton="default" [disabled]="currentPage === totalPages" (click)="changePage(currentPage + 1)">&gt;</button>
        </div>
      </div>
    </div>
  </div>
</shabic-layout> 